import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useMe } from "@/shared/api/auth";
import { isMember } from "@/shared/api/projects";

export function LoadingScreen() {
  return (
    <div className="flex min-h-(--app-h) items-center justify-center text-[13px] text-muted">
      Betöltés…
    </div>
  );
}

function ServerDown() {
  return (
    <div className="flex min-h-(--app-h) flex-col items-center justify-center gap-3 px-6 text-center">
      <p className="text-[15px] text-ink-soft">
        Nem érhető el a szerver. Próbáld újra kicsit később.
      </p>
    </div>
  );
}

export function RequireAuth({ children, admin = false }: { children: ReactNode; admin?: boolean }) {
  const { data: me, isPending, isError } = useMe();
  const location = useLocation();

  if (isPending) return <LoadingScreen />;
  if (isError) return <ServerDown />;
  if (!me) {
    const next = location.pathname + location.search;
    return <Navigate to={`/app/belepes?next=${encodeURIComponent(next)}`} replace />;
  }
  if (admin && me.role !== "admin") {
    return <Navigate to="/app" replace />;
  }
  return <>{children}</>;
}

/** Projekt-útvonalak őre: belépés + tagság. Tagság nélkül a csatlakozás-oldalra visz
 *  (a szerver ugyanezt `403 not_member`-rel jelzi) — rendszerterv 4. */
export function RequireMember({
  project,
  joinPath,
  children,
}: {
  project: string;
  joinPath: string;
  children: ReactNode;
}) {
  const { data: me, isPending, isError } = useMe();
  const location = useLocation();

  if (isPending) return <LoadingScreen />;
  if (isError) return <ServerDown />;
  if (!me) {
    const next = location.pathname + location.search;
    return (
      <Navigate
        to={`/app/belepes?project=${project}&next=${encodeURIComponent(next)}`}
        replace
      />
    );
  }
  if (!isMember(me, project)) return <Navigate to={joinPath} replace />;
  return <>{children}</>;
}
